import React from "react";
import { Button, Space, DatePicker, Popconfirm, Tooltip, Select } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faRotateRight, faFileCsv, faFilter, faTrash, faFilterCircleXmark,
} from "@fortawesome/free-solid-svg-icons";
import { quickRanges } from "../log-utils";

const { RangePicker } = DatePicker;

// Chu kỳ tự động làm mới. 0 = tắt (mặc định) để không bắn query nền vô ích.
const AUTO_REFRESH_OPTIONS = [
    { value: 0, label: "Tự làm mới: tắt" },
    { value: 15, label: "Mỗi 15 giây" },
    { value: 30, label: "Mỗi 30 giây" },
    { value: 60, label: "Mỗi 1 phút" },
    { value: 300, label: "Mỗi 5 phút" },
];

// Thanh công cụ dùng chung cho mọi tab log.
// children = các ô filter riêng của tab (Select/Input...).
// Bố cục 2 hàng: (1) lọc nhanh theo mốc thời gian; (2) lọc chi tiết + hành động.
function LogToolbar({ t, onRefresh, children }) {
    const ranges = quickRanges();
    // Nút lọc nhanh đang chọn được highlight (so khớp from/to đã lưu).
    const isActive = (r) => t.f.from === r.from && t.f.to === r.to;

    // Xoá hàng loạt chỉ mở khi:
    //  - có kết quả (t.total)
    //  - bộ lọc ĐÃ ÁP DỤNG khác rỗng (where rỗng = xoá sạch bảng; backend cũng chặn)
    //  - không còn ô lọc nào đang gõ dở (nếu không, số trên nút là của bộ lọc cũ)
    const canDeleteAll = !!t.total && t.appliedHasFilter && !t.isDirty;
    const deleteAllHint = t.isDirty
        ? "Bấm Lọc trước đã — số dòng trên nút đang là của bộ lọc trước đó"
        : !t.appliedHasFilter
            ? "Phải đặt ít nhất 1 bộ lọc trước khi xoá hàng loạt"
            : "";

    return (
        <div style={{ marginBottom: 12 }}>
            {/* Hàng 1: lọc nhanh theo mốc thời gian */}
            <Space wrap size={[8, 8]} style={{ marginBottom: 10 }}>
                {ranges.map((r) => (
                    <Button
                        key={r.label}
                        size="small"
                        type={isActive(r) ? "primary" : "default"}
                        onClick={() => t.applyQuickRange(r.from, r.to)}
                    >
                        {r.label}
                    </Button>
                ))}
                <Select
                    size="small"
                    style={{ width: 150 }}
                    value={t.autoRefresh}
                    onChange={t.setAutoRefresh}
                    options={AUTO_REFRESH_OPTIONS}
                />
            </Space>

            {/* Hàng 2: lọc chi tiết + hành động */}
            <Space wrap size={[8, 8]}>
                {children}

                <RangePicker showTime size="middle" value={t.rangeValue} onChange={t.setRange} />

                <Button type="primary" icon={<FontAwesomeIcon icon={faFilter} />} onClick={t.search}>
                    Lọc
                </Button>

                <Tooltip title="Xoá mọi bộ lọc">
                    <Button
                        icon={<FontAwesomeIcon icon={faFilterCircleXmark} />}
                        disabled={!t.hasFilter}
                        onClick={t.clear}
                    />
                </Tooltip>

                <Tooltip title="Tải lại">
                    <Button icon={<FontAwesomeIcon icon={faRotateRight} />} loading={t.loading} onClick={onRefresh} />
                </Tooltip>

                <Tooltip title={`Xuất CSV toàn bộ ${t.total} dòng khớp bộ lọc`}>
                    <Button
                        icon={<FontAwesomeIcon icon={faFileCsv} />}
                        loading={t.exporting}
                        disabled={!t.total}
                        onClick={t.downloadCsv}
                    />
                </Tooltip>

                <Popconfirm
                    title={`Xoá ${t.selected.length} dòng đã chọn?`}
                    onConfirm={t.del} okText="Xoá" cancelText="Hủy" okButtonProps={{ danger: true }}
                    disabled={!t.selected.length}
                >
                    <Button danger icon={<FontAwesomeIcon icon={faTrash} />} disabled={!t.selected.length}>
                        Xoá đã chọn ({t.selected.length})
                    </Button>
                </Popconfirm>

                <Tooltip title={deleteAllHint}>
                    <Popconfirm
                        title={`Xoá TẤT CẢ ${t.total} dòng khớp bộ lọc hiện tại?`}
                        description="Xoá toàn bộ kết quả lọc (mọi trang). Không thể hoàn tác."
                        onConfirm={t.delAll} okText="Xoá tất cả" cancelText="Hủy" okButtonProps={{ danger: true }}
                        disabled={!canDeleteAll}
                    >
                        <Button danger disabled={!canDeleteAll}>
                            Xoá tất cả theo lọc ({t.total})
                        </Button>
                    </Popconfirm>
                </Tooltip>
            </Space>
        </div>
    );
}

export default LogToolbar;
